import { Player } from '../players';

export interface Score {
  points: number;
}

export enum GameStatus {
  Started = 'started',
  NotStarted = 'not-stated',
  Scored = 'scored',
}

export type Game = GameNotStarted | GameStarted | GameScored;

export interface GameStarted {
  currentPlayer: number;
  status: GameStatus.Started;
  players: Player[];
  scores: Record<string, Score>;
}

export interface GameScored {
  status: GameStatus.Scored;
  players: Player[];
  scores: Record<string, Score>;
}

export interface GameNotStarted {
  status: GameStatus.NotStarted;
}

export interface GameApi {
  start(players: Player[]): Promise<void>;
  score(): Promise<Game>;
  restart(): Promise<Game>;
  addToScore(points: number): Promise<void>;
  currentGame(): Promise<Game>;
}
